(function ($) {
	"use strict";

	// Preloader
	$(window).on("load", function () {
		$("body").addClass("loaded");
	});

	$(document).ready(function () {

		// Sticky Header
		function stickyHeader() {
			var primaryHeader = $(".nav-menu-wrapper"),
				headerClone = primaryHeader.clone();
			$(".main-header").after('<div class="sticky-header"></div>');
			$(".sticky-header").html(headerClone);

			var headerSelector = document.querySelector(".sticky-header"),
				triggerPoint = $(".main-header").height(),
				yOffset = 0;

			$(window).on("scroll", function () {
				yOffset = $(window).scrollTop();
				if (yOffset >= triggerPoint) {
					$(".sticky-header").addClass("sticky-fixed-top");
					$("body.open-sidebox").removeClass("open-sidebox");
				} else {
					$(".sticky-header").removeClass("sticky-fixed-top");
				}
			});
		}

		if ($(window).width() > 992) {
			stickyHeader();
		}

		// Mobile Menu
		function mobileMenu() {
			if ($(".header-menu-wrap").length) {
				$(".nav-menu-inner .burger-menu").on("click", function () {
					$(this).toggleClass("menu-open");
					$(".header-menu-wrap").slideToggle(300);
				});
			}

			$(".header-menu-wrap ul li:has(ul)").each(function () {
				$(this).append('<span class="dropdown-plus"></span>');
				$(this).addClass("dropdown_menu");
			});

			$(".header-menu-wrap .dropdown-plus").on("click", function () {
				$(this).prev("ul").slideToggle(300);
				$(this).toggleClass("dropdown-open");
				$(".header-menu-wrap ul li:has(ul)").toggleClass("dropdown-open");
			});

			$(".header-menu-wrap .dropdown_menu a").append("<span></span>");
		}

		mobileMenu();

		// Responsive Classes
		function responsiveClasses() {
			var body = $("body");
			if ($(window).width() < 992) {
				body.removeClass("viewport-lg");
				body.addClass("viewport-sm");
			} else {
				body.removeClass("viewport-sm");
				body.addClass("viewport-lg");
			}
		}

		// Window Resize
		$(window).on("resize", function () {
			responsiveClasses();
		}).resize();

		// Popup Sidebox
		function sideBox() {
			$("body").removeClass("open-sidebox");
			$(document).on("click", ".dl-sidebox-icon", function (e) {
				e.preventDefault();
				$("body").toggleClass("open-sidebox");
			});
			$(document).on("click", "#sidebox-overlay", function (e) {
				e.preventDefault();
				$("body.open-sidebox").removeClass("open-sidebox");
			});
		}

		sideBox();

		function doAnimations(elements) {
			var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
			elements.each(function () {
				var $this = $(this);
				var $animationDelay = $this.data('delay');
				var $animationDuration = $this.data('duration');
				var $animationType = 'animated ' + $this.data('animation');
				$this.css({
					'animation-delay': $animationDelay,
					'-webkit-animation-delay': $animationDelay,
					'animation-duration': $animationDuration
				});
				$this.addClass($animationType).one(animationEndEvents, function () {
					$this.removeClass($animationType);
				});
			});
		}

		// Main Slider
		var mainSlider;
		var sliderOptions = {
			speed: 1000,
			autoplay: false,
			parallax: false,
			mousewheel: false,
			loop: true,
			effect: 'fade',
			a11y: false,
			pagination: {
				el: '.main-slider .slider-pagination',
				clickable: true,
				type: 'fraction', //fraction
			},
			navigation: {
				nextEl: '.main-slider .slider-button-next',
				prevEl: '.main-slider .slider-button-prev'
			}
		};

		sliderOptions.on = {
			slideChangeTransitionStart: function () {
				var swiper = this;
				var animatingElements = $(swiper.slides[swiper.activeIndex]).find('[data-animation]');
				doAnimations(animatingElements);
			},
			resize: function () {
				this.update();
			}
		};

		mainSlider = new Swiper('.main-slider', sliderOptions);


		//Service Carousel  
		var swiperService = new Swiper(".service-carousel", {
			slidesPerView: "3",
			spaceBetween: 30,
			slidesPerGroup: 1,
			loop: true,
			autoplay: false,
			speed: 400,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-outside .swiper-next",
				prevEl: ".swiper-outside .swiper-prev",
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 25
				},
				// when window width is >= 767px
				767: {
					slidesPerView: 2,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				// when window width is >= 1024px
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 1
				}
			}
		});

		// Scroll To Top
		var scrollTop = $("#scroll-top");
		$(window).on("scroll", function () {
			var topPos = $(this).scrollTop();
			if (topPos > 100) {
				$("#scrollup").removeClass("hide");
				$("#scrollup").addClass("show");
			} else {
				$("#scrollup").removeClass("show");
				$("#scrollup").addClass("hide");
			}
		});

		$(scrollTop).on("click", function () {
			$('html, body').animate({
				scrollTop: 0
			}, 800);
			return false;
		});

		// Wow JS Active
		new WOW().init();

		// Nice Select
		$('select').niceSelect();  

		// Date Time Picker
		$('.date-picker').datetimepicker({
			timepicker: false,
			format:'d/m/Y'
		}); 

	});
})(jQuery);